import React from 'react';
import PropTypes from 'prop-types';
import { usePressEscape, useProjectAction } from 'hooks';
import { SchedulerEditProjectItems } from '@hub-mono/app-modules';
import { usePhases } from '../../../hooks';
import { useMilestones } from '../../../hooks/useMilestones';
import { useProjectDates } from '../../../hooks/useProjectDates';
import { removeDaypilotEvent } from '../../../utils/schedulerUtil';
import { updateBookingSelection } from '../../../../../actions/schedulerActions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentSelectedBooking } from '../../../../../selectors/scheduler';

const EditResourceParentItems = ({ top, left, close, schedulerRef }) => {
    usePressEscape(close);


    const currentSelectedBooking = useSelector(selectCurrentSelectedBooking);
    const dispatch = useDispatch();
    const { updatePhase, deletePhase } = usePhases(schedulerRef, close);
    const { updateMilestone, deleteMilestone } = useMilestones(schedulerRef, close);
    const { updateProjectDates } = useProjectDates(schedulerRef, close);
    const { updateProject } = useProjectAction(schedulerRef);

    const onDeleteProjectItem = () => {
        if (currentSelectedBooking.milestone) {
            deleteMilestone();
            close && close();
        }
        if (currentSelectedBooking.phase) {
            deletePhase();
            close && close();
        }
        if (currentSelectedBooking.datesEvent) {
            dispatch(
                updateProject(currentSelectedBooking.projectId, {
                    project: {
                        start: null,
                        end: null,
                        useProjectDuration: false,
                    },
                })
            );
            removeDaypilotEvent(`start_${currentSelectedBooking.projectId}`);
            removeDaypilotEvent(`end_${currentSelectedBooking.projectId}`);
            close && close();
            dispatch(updateBookingSelection.request());
        }
    };

    return (
        <SchedulerEditProjectItems
            isOpen
            position={{ top, left }}
            onClose={close}
            onUpdatePhase={updatePhase}
            onUpdateMilestone={updateMilestone}
            onUpdateProjectDates={updateProjectDates}
            onDeleteProjectItem={onDeleteProjectItem}
        />
    );
};

EditResourceParentItems.propTypes = {
    schedulerRef: PropTypes.object.isRequired,
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    close: PropTypes.func.isRequired,
};

export default EditResourceParentItems;
